import { createAsyncThunk } from '@reduxjs/toolkit';

import MarketService from 'api/market/MarketService';
import { addNotification } from '../../notification/slice';
import { setOrderbook } from './slice';

import { initialOrderbookState } from './slice';

import { NotificationType, OrderbookT } from 'types';

import { throttle } from 'utils';

export const subscribeOrderbook = createAsyncThunk(
  'market/subscribeOrderbook',
  throttle(async (instrument_id: string, { dispatch, extra }: any) => {
    try {
      dispatch(setOrderbook(initialOrderbookState.orderbook));
      const marketService = extra.marketService as MarketService;

      marketService.subscribeOrderbook(instrument_id, {
        next: ({ data: { orderbook } }: { data: { orderbook: OrderbookT } }) => {
          dispatch(setOrderbook(orderbook));
        },
        error: (error: any) => {
          dispatch(addNotification({ type: NotificationType.Canceled, msg: error.toString() }));
        },
        complete: () => {},
      });
    } catch (error: any) {
      dispatch(addNotification({ type: NotificationType.Canceled, msg: error.toString() }));
    }
  }, 1000)
) as (instrument_id: string) => any;
